import { Construction } from "lucide-react";

export default function Placeholder({ title }) {
  return (
    <div className="space-y-6" data-testid="placeholder-page">
      <div>
        <h1 className="font-heading text-3xl sm:text-4xl font-extrabold tracking-tight uppercase">{title}</h1>
        <p className="text-sm text-slate-400 mt-1">Data model is scaffolded. This module is not built yet.</p>
      </div>
      <div className="border border-dashed border-slate-700 rounded-md p-12 flex flex-col items-center justify-center text-center bg-slate-900/40">
        <div className="h-14 w-14 rounded-md bg-slate-800 flex items-center justify-center mb-4">
          <Construction className="h-7 w-7 text-orange-400" />
        </div>
        <div className="font-heading text-xl font-bold uppercase tracking-wide text-slate-200">Module Coming Soon</div>
        <p className="text-sm text-slate-500 mt-2 max-w-md">
          The foundation (database schema, migrations, auth & inventory engine) is in place.
          Business workflows will be implemented in upcoming milestones.
        </p>
      </div>
    </div>
  );
}
